var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3735 4.23954C14.5693 4.4342 14.5703 4.75078 14.3757 4.94664C12.6283 6.70483 11.2306 8.10103 10.0494 9.27931C9.83474 9.49342 9.6273 9.70029 9.42623 9.9008C8.52045 10.8041 7.74411 11.5782 7.0231 12.3034C6.92939 12.3976 6.80201 12.4507 6.66911 12.4508C6.53621 12.451 6.40871 12.3982 6.31479 12.3042L2.63758 8.62293C2.44243 8.42756 2.4426 8.11097 2.63797 7.91582C2.83334 7.72067 3.14993 7.72084 3.34508 7.91621L6.66796 11.2428C7.29077 10.6181 7.96084 9.94986 8.72076 9.19206C8.92168 8.99169 9.12888 8.78507 9.34315 8.57133C10.5238 7.39355 11.9204 5.99848 13.6664 4.24172C13.861 4.04585 14.1776 4.04488 14.3735 4.23954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.38f33023fcdea8777fe02e0e58bf0700.svg";
export { ForwardRef as ReactComponent };